export default $axios => ({
  store(payload) {
    return $axios.post('v1/contacts', payload);
  }
});
